import { defineStore } from 'pinia'
import axios, { AxiosError } from 'axios'
import { useCacheService } from '@/shared/composables/useCacheService'
import { formatDate } from '@/shared/utils'
import { useApiNew } from '@/shared/composables/useApi'
import { PolicyListItem } from '../types/policy.types'

interface PolicyState {
  person: {
    passportNo?: string
    birthdate?: Date
  }
  policyList: PolicyListItem[]
}

const POLICY_STATE_KEY = 'policy-state'
const apiService = useApiNew()
const cacheService = useCacheService('session')

export const ERROR_TOO_MANY_REQUETS = 'TOO MANY REQUESTS ERROR'
export const ERROR_NO_POLICY_FOUND = 'NO POLICY FOUND ERROR'
const ERROR_NOT_FOUND = 'NOT FOUND ERROR'

const isToManyRequestsError = (error: Error | AxiosError): boolean => axios.isAxiosError(error) && error?.response?.status === 429

export const usePolicyStore = defineStore('policy', {
  state: (): PolicyState => {
    const cached = cacheService.get(POLICY_STATE_KEY)
    const passportNo = cached?.passportNo
    const birthdate = cached?.birthdate ? new Date(cached.birthdate) : undefined

    return {
      person: {
        passportNo,
        birthdate,
      },
      policyList: [],
    }
  },
  actions: {
    async fetchPolicyList(
      passportNo: string,
      birthdate: Date,
      captchaToken: string,
      controller?: AbortController
    ): Promise<PolicyListItem[] | undefined> {
      try {
        const resp = await apiService.policyService?.getPolicyList(
          passportNo,
          formatDate(birthdate, 'en'),
          captchaToken,
          controller
        )
        this.policyList = resp || []
        return this.policyList
      } catch (error: any) {
        if (isToManyRequestsError(error)) {
          throw new Error(ERROR_TOO_MANY_REQUETS)
        }

        if (error.message === 'no_name_error') {
          throw new Error(ERROR_NOT_FOUND)
        }

        throw error
      }
    },
    setPerson(passportNo: string, birthdate?: Date) {
      this.person.passportNo = passportNo
      this.person.birthdate = birthdate || this.person.birthdate
      cacheService.set(POLICY_STATE_KEY, this.person)
    },
  },
})
